import { combine, createEffect, createEvent, createStore } from 'effector';
import createPreloadersStore from './preloaders';
import request from '@helpers/request';
import api from '@constants/endpoints';
import createPaginationStore from './pagination';
import { get } from 'lodash';
import { ITribes } from '@interfaces/ITribes';
import { TribeMembersFiltersValue } from '@helpers/tribesFilters';

interface IMembersListId extends TribeMembersFiltersValue {
  tribeId: ITribes['id'];
}

export const reset = createEvent('TribesMembers store reset');

export const getList = createEffect({
  name: 'getList',
  async handler({ tribeId, nickname }: IMembersListId) {
    const { current, pageSize } = pagination.getState();
    const params = {
      page: (current || 1) - 1,
      pageSize,
      type: 'PAGE',
      filter: nickname ? { nickname } : {},
    };

    const response = await request(api.tribes.getMembersList, {
      data: params,
      urlParams: { tribeId },
    });
    return response;
  },
});

export const banMember = createEffect({
  name: 'banMember',
  async handler({ tribeId, accountId }: { tribeId: string; accountId: string }) {
    return request(api.tribes.banMember, { urlParams: { tribeId, accountId } });
  },
});

export const unbanMember = createEffect({
  name: 'unbanMember',
  async handler({ tribeId, accountId }: { tribeId: string; accountId: string }) {
    return request(api.tribes.unbanMember, { urlParams: { tribeId, accountId } });
  },
});

const preloaders = createPreloadersStore([getList, banMember, unbanMember]);

const { pagination, setPagination } = createPaginationStore({
  getList,
  listName: 'trbesMembers',
  resetEvent: reset,
  bodyPath: ['data', 'body'],
});

export { setPagination };

const list = createStore<any[]>([])
  .on(getList.done, (state, { result }) => get(result, ['data', 'body', 'page'], []))
  .on(banMember.done, (state, { params }) => {
    const { accountId } = params;
    return state.map((item) =>
      String(item?.account?.id) === String(accountId) ? { ...item, role: 'BANNED' } : item,
    );
  })
  .on(unbanMember.done, (state, { params }) => {
    const { accountId } = params;
    return state.map((item) =>
      String(item?.account?.id) === String(accountId) ? { ...item, role: 'MEMBER' } : item,
    );
  })
  .reset(reset);

const tribesMembers = combine({ list, preloaders, pagination, setPagination });

export default tribesMembers;
